module.exports = __webpack_public_path__ + "static/img/header-bg-vip.b68708f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/header-bg-vip.png
// module id = g+Pg
// module chunks = 215